import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from "react";
import { MDXProvider } from "@mdx-js/react";
import { Tweet, YouTube, CodePen, CodeSandbox, Gist } from "mdx-embed";
import components from "../src/components";
import { Link, Divider, Blockquote, CodeBlock, Table, Aside, Highlight, Example, Tag // Embed
, Bilibili, NeteaseMusic } from "../src/components/MDX";
import AspectRatio from "../src/components/AspectRatio";
export var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/React.createElement(MDXProvider, {
    components: _objectSpread({
      a: Link,
      hr: Divider,
      blockquote: Blockquote,
      pre: CodeBlock,
      table: Table,
      // Extended Components
      Link: Link,
      Tag: Tag,
      Aside: Aside,
      Highlight: Highlight,
      Example: Example,
      Bilibili: Bilibili,
      NeteaseMusic: NeteaseMusic,
      // Mdx Embed
      Tweet: Tweet,
      YouTube: YouTube,
      CodePen: CodePen,
      CodeSandbox: CodeSandbox,
      Gist: Gist,
      // Common Components
      AspectRatio: AspectRatio
    }, components)
  }, element);
};